
import escClose from './esc-close'

const install = function(Vue) {
  Vue.directive('esc-close', escClose)
}

if (window.Vue) {
  window['esc-close'] = escClose
  Vue.use(install); // eslint-disable-line
}

escClose.install = install
export default escClose

